<template lang="pug">
  .product-line-item(v-if="product && product.id")
    .product-image-wrap
      img.full-width(:src="product.imagery.standard.url" :alt="product.imagery.standard.alt_text")
    .product-details
      p.prod-type.upper.bold.xs-f-small.max-at-tweak {{product.product_type_name}}
      p.color-slate.xs-f-xsmall.max-at-tweak {{product.name}}
      p.color-slate.xs-f-xsmall.max-at-tweak {{product.desc.short}}
    .product-price
      p.price.semi-bold.xs-f-small.max-at-tweak {{product.price | freeCurrency}}
</template>

<script>
  export default {
    name: "ProductLineItem",

    props: {
      product: {
        type: Object
      }
    }
  }
</script>

<style scoped lang="stylus">
  .product-line-item
    text-align left
    padding 1em 0
    border-bottom 1px solid color-fog-light
    
    .product-image-wrap
    .product-details
    .product-price
      display inline-block
      vertical-align top
      
    .product-image-wrap
      width 3.25em
    
    .product-details
      width 12em
      padding-left 1em
      padding-right 0.5em
      
      .prod-type
        padding-bottom 0.5em
      
    .product-price
      width 4em
      text-align right
      float right
      
    @media mq-desktop-plus
      .product-details
        width 18em
      
</style>
